import React, { useRef } from 'react';
// import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import emailjs from '@emailjs/browser';

const FormStyle = styled.form`
  width: 100%;
  .form-group {
    width: 100%;
    margin-bottom: 2rem;
  }
  label {
    font-size: 1.8rem;
  }
  input,
  textarea {
    width: 100%;
    font-size: 2rem;
    padding: 1.2rem;
    color: var(--gray-1);
    background-color: var(--deep-dark);
    outline: none;
    border: none;
    border-radius: 8px;
    margin-top: 1rem;
  }
  textarea {
    min-height: 250px;
    resize: vertical;
  }
  button[type='submit'] {
    width: 50%;
    background-color: var(--gray-1);
    color: var(--black);
    font-size: 2rem;
    display: inline-block;
    outline: none;
    border: none;
    padding: 1rem 4rem;
    border-radius: 8px;
    cursor: pointer;
  }
`;

export default function ContactForm() {
  // const [name, setName] = useState('');
  // const [email, setEmail] = useState('');
  // const [subject, setSubject] = useState('');
  // const [message, setMessage] = useState('');

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'gmailMessage',
        'template_1egu8tg',
        form.current,
        'VLljEm5n5sIPtKKaE'
      )
      .then(
        (result) => {
          console.log(result.text);
          alert('Mensagem enviada com sucesso!');
          alert(
            'Obrigado por entrar em contato, responderei assim que possível!'
          );
        },
        (error) => {
          console.log(error.text);
          alert('Sua mensagem não pode ser enviada!');
          alert('Verifique as informações inseridas');
        }
      );
    form.current.reset();
  };

  return (
    <>
      <FormStyle className="form-group" ref={form} onSubmit={sendEmail}>
        <div className="form-group">
          <label htmlFor="name">
            Seu Nome
            <input
              type="text"
              id="name"
              name="name"
              // value={name}
              required
              // onChange={(e) => setName(e.target.value)}
            />
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="email">
            Seu Email
            <input
              type="email"
              id="email"
              name="email"
              // value={email}
              required
              // onChange={(e) => setEmail(e.target.value)}
            />
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="subject">
            Assunto
            <input
              type="subject"
              id="subject"
              name="subject"
              // value={subject}
              required
              // onChange={(e) => setSubject(e.target.value)}
            />
          </label>
        </div>
        <div className="form-group">
          <label htmlFor="message">
            Sua Mensagem
            <textarea
              type="text"
              id="message"
              name="message"
              // value={message}
              required
              // onChange={(e) => setMessage(e.target.value)}
            />
          </label>
        </div>
        <button type="submit">Enviar</button>
      </FormStyle>
    </>
  );
}
